import React from 'react'
import { useStateValue } from '@State'

export const ActivitiesContainer = ({selectedResourceIds, handleCheck}) => {
  const [currentState] = useStateValue()

  return (
    <React.Fragment>
      <div className="d-flex justify-content-between">
        <div>
          {currentState.connectedCourses && currentState.connectedCourses.map(course => {
            return (<div key={course.coursenum}>
              <h2>{course.bookTitle}</h2>
              <h3>Assessments</h3>
              {course.activity_groups.map((ag, outer_idx) => {
                return (<div className="ml-4" key={outer_idx}>
                  {ag.title}
                  {ag.activities.length === 0 && <p className="mt-2 ml-4">No assessments in this group</p>}
                  {ag.activities.map(( act, inner_idx ) => {
                    return (
                      <div className="ml-4" key={act.id}>
                        <input 
                          type="checkbox"
                          id={act.guid}
                          name={act.title}
                          value={act.id}
                          onChange={handleCheck}
                          checked={selectedResourceIds.includes(`${act.id}-${outer_idx}-${inner_idx}`)}
                          data-sort-idx={`${outer_idx}-${inner_idx}`}
                        />
                        <label className="ml-2" htmlFor={act.guid}>{act.title} | {act.points} pts</label>
                      </div>)
                    })}
                </div>)
              })}
            </div>)
          })}
        </div>
      </div>
    </React.Fragment>
  )
}

